
import { useState, useEffect } from 'react';

export default function PromiseSection() {
  const [activeImage, setActiveImage] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);

  const images = [
    {
      src: "https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/7d3a967d0cb44dca547057fb09614225.png",
      alt: "Piscina con vista al mar",
      title: "Piscina Paradisíaca",
      description: "Relájate en nuestra piscina con vista espectacular al mar Caribe"
    },
    {
      src: "https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/742f9ba89ad0007192409d8414b4dc89.png",
      alt: "Playa Castilletes",
      title: "Playa Castilletes",
      description: "Acceso directo a una de las playas más hermosas del Tayrona"
    },
    {
      src: "https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/ea292ecfa78c50d750becda23cfef6df.jpeg",
      alt: "Desayuno tradicional",
      title: "Desayuno Gourmet",
      description: "Sabores auténticos con productos frescos y locales"
    }
  ];

  const services = [
    {
      icon: 'ri-swimming-pool-line',
      title: 'Piscina',
      description: 'Relájate en nuestra piscina con vista al mar'
    },
    {
      icon: 'ri-sun-line',
      title: 'Playa',
      description: 'Acceso directo a Playa Castilletes (NO APTO PARA EL BAÑO)'
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Desayuno',
      description: 'Desayuno incluido con productos locales'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Naturaleza',
      description: 'Inmersión total en el Parque Tayrona'
    }
  ];

  // Auto-play del carrusel
  useEffect(() => {
    if (!isPlaying) return;
    
    const interval = setInterval(() => {
      setActiveImage((prev) => (prev + 1) % images.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [isPlaying, images.length]);

  const nextImage = () => {
    setActiveImage((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setActiveImage((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <section className="py-20 bg-gradient-to-b from-teal-50 to-white">
      <div className="container mx-auto px-4">
        {/* Galería Interactiva Mejorada */}
        <div className="mb-16">
          {/* Carrusel principal destacado */}
          <div className="relative mb-8">
            <div className="relative h-96 md:h-[500px] rounded-2xl overflow-hidden shadow-2xl group">
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent z-10"></div>
              
              {images.map((image, index) => (
                <div
                  key={index}
                  className={`absolute inset-0 transition-all duration-700 ease-in-out ${
                    index === activeImage 
                      ? 'opacity-100 scale-100' 
                      : 'opacity-0 scale-105'
                  }`}
                >
                  <img 
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-full object-contain bg-gray-100"
                  />
                </div>
              ))}

              {/* Overlay con información */}
              <div className="absolute bottom-0 left-0 right-0 p-8 z-20 text-white">
                <h3 className="text-2xl md:text-3xl font-bold mb-2">
                  {images[activeImage].title}
                </h3>
                <p className="text-lg opacity-90">
                  {images[activeImage].description}
                </p>
              </div>

              {/* Controles de navegación */}
              <button
                onClick={prevImage}
                className="absolute left-4 top-1/2 -translate-y-1/2 z-30 w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-all duration-300 group-hover:scale-110"
              >
                <i className="ri-arrow-left-line text-xl"></i>
              </button>

              <button
                onClick={nextImage}
                className="absolute right-4 top-1/2 -translate-y-1/2 z-30 w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-all duration-300 group-hover:scale-110"
              >
                <i className="ri-arrow-right-line text-xl"></i>
              </button>

              {/* Control de play/pause */}
              <button
                onClick={() => setIsPlaying(!isPlaying)}
                className="absolute top-4 right-4 z-30 w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-all duration-300"
              >
                <i className={`${isPlaying ? 'ri-pause-line' : 'ri-play-line'} text-lg`}></i>
              </button>
            </div>

            {/* Indicadores de puntos */}
            <div className="flex justify-center space-x-3 mt-6">
              {images.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveImage(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${
                    index === activeImage 
                      ? 'bg-teal-600 scale-125' 
                      : 'bg-gray-300 hover:bg-gray-400'
                  }`}
                />
              ))}
            </div>
          </div>

          {/* Grid de miniaturas */}
          <div className="grid grid-cols-3 gap-4">
            {images.map((image, index) => (
              <div 
                key={index}
                className={`relative h-32 md:h-40 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 ${
                  index === activeImage 
                    ? 'ring-4 ring-teal-500 shadow-xl scale-105' 
                    : 'hover:scale-102 hover:shadow-lg'
                }`}
                onClick={() => setActiveImage(index)}
              >
                <img 
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-full object-contain bg-gray-100 transition-transform duration-300 hover:scale-110"
                />
                <div className={`absolute inset-0 transition-all duration-300 ${
                  index === activeImage 
                    ? 'bg-teal-600/20' 
                    : 'bg-black/20 hover:bg-black/10'
                }`}></div>
                {index === activeImage && (
                  <div className="absolute top-2 right-2 w-6 h-6 bg-teal-600 rounded-full flex items-center justify-center">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Estadísticas visuales */}
          <div className="grid grid-cols-3 gap-6 mt-8">
            <div className="text-center p-4 bg-white/50 rounded-xl backdrop-blur-sm">
              <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-2">
                <i className="ri-camera-line text-teal-600 text-xl"></i>
              </div>
              <div className="text-2xl font-bold text-gray-800">3</div>
              <div className="text-sm text-gray-600">Espacios Únicos</div>
            </div>
            
            <div className="text-center p-4 bg-white/50 rounded-xl backdrop-blur-sm">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-2">
                <i className="ri-star-line text-blue-600 text-xl"></i>
              </div>
              <div className="text-2xl font-bold text-gray-800">5★</div>
              <div className="text-sm text-gray-600">Experiencia</div>
            </div>
            
            <div className="text-center p-4 bg-white/50 rounded-xl backdrop-blur-sm">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-2">
                <i className="ri-heart-line text-green-600 text-xl"></i>
              </div>
              <div className="text-2xl font-bold text-gray-800">100%</div>
              <div className="text-sm text-gray-600">Natural</div>
            </div>
          </div>
        </div>

        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
            Nuestra Promesa
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Vive la magia del Tayrona con comodidad. Despierta con el mar, 
            refréscate en la piscina. Una experiencia única donde la naturaleza 
            y el confort se encuentran en perfecta armonía.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 text-center group hover:-translate-y-2">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-teal-600 transition-colors">
              <i className="ri-swimming-pool-line text-2xl text-teal-600 group-hover:text-white transition-colors"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">Piscina</h3>
            <p className="text-gray-600">Relájate en nuestra piscina con vista al mar.</p>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 text-center group hover:-translate-y-2">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-teal-600 transition-colors">
              <i className="ri-sun-line text-2xl text-teal-600 group-hover:text-white transition-colors"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">Playa</h3>
            <p className="text-gray-600">Acceso directo a Playa Castilletes (NO APTO PARA EL BAÑO)</p>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 text-center group hover:-translate-y-2">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-teal-600 transition-colors">
              <i className="ri-restaurant-line text-2xl text-teal-600 group-hover:text-white transition-colors"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">Desayuno</h3>
            <p className="text-gray-600">Desayuno incluido con productos locales</p>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-30 text-center group hover:-translate-y-2">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-teal-600 transition-colors">
              <i className="ri-leaf-line text-2xl text-teal-600 group-hover:text-white transition-colors"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">Naturaleza</h3>
            <p className="text-gray-600">Inmersión total en el Parque Tayrona</p>
          </div>
        </div>
      </div>
    </section>
  );
}
